const getSiteUrl = () =>
  (process.env.REACT_APP_BASE_URL || "https://fursatook.com").replace(/\/$/, "");

const DEFAULT_OG_IMAGE = "/fursatook-logo.jpg";

const toAbsoluteUrl = (url) => {
  if (!url) return `${getSiteUrl()}${DEFAULT_OG_IMAGE}`;
  if (url.startsWith("http://") || url.startsWith("https://")) return url;
  return `${getSiteUrl()}${url.startsWith("/") ? url : `/${url}`}`;
};

export { getSiteUrl, DEFAULT_OG_IMAGE, toAbsoluteUrl };
